import { Component, OnInit, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common'; // 🚀 INYECTADO DETECTOR NATIVO
import { FormBuilder, FormGroup, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

import { UdcsService } from '../../Service/udcs-service';
import { ToastService } from '../../Service/toast-service';
import { AuthService } from '../../Service/auth';
import { RecepcionesService } from '../../Service/recepciones-service'; 
import { PersonalService } from '../../Service/personal-service'; // 🚀 INYECTADO: Nuevo servicio del Address Book Staff

@Component({
  selector: 'app-user-add',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './user-add.html',
  styleUrl: './user-add.css',
})
export class UserAdd implements OnInit {
  userForm!: FormGroup;
  catRolesUdc: any[] = []; // Almacena [{ id: 464, description: 'ROLE_ADMIN' }, ...]
  empleadosF0101: any[] = []; // Listado blindado [{ an8: 1, nameAlpha: 'JUANITO PEREZ', searchType: 'E' }]

  constructor(
    private fb: FormBuilder,
    private udcService: UdcsService,
    private toastService: ToastService,
    private authService: AuthService,
    private personalService: PersonalService, // 🚀 INYECTADO COHERENTEMENTE
    private router: Router,
    private cdr: ChangeDetectorRef,
    private recepcionesService: RecepcionesService,
    public dialogRef: MatDialogRef<UserAdd>,
    @Inject(PLATFORM_ID) private platformId: Object // 🚀 INYECTADO: Detecta si es Chrome o Node.js
  ) {}

  ngOnInit(): void {
    // Inicialización síncrona del FormGroup (Se mantiene 100% idéntica e intacta)
    this.userForm = this.fb.group({
      userId: ['', [Validators.required, Validators.minLength(3), Validators.pattern('^[a-zA-Z0-9_]*$')]],
      an8: [null, Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      enabled: [true],
      rolesSeleccionados: this.fb.array([]) 
    });

    // =========================================================================
    // 🛡️ CANDADO DE SEGURIDAD SAAS CONTRA BLOQUEO SSR (HIERRO AL 100%)
    // SOLUCIÓN: Si Angular pre-renderea esto en Node.js, abortamos las peticiones HTTP.
    // Las llamadas correrán ÚNICA Y EXCLUSIVAMENTE cuando el modal ya esté vivo en Chrome.
    // =========================================================================
    if (isPlatformBrowser(this.platformId)) {
      console.log('📶 [SaaS Seguridad] Ejecutando de forma segura en Google Chrome. Cargando catálogos...');
      this.cargarRolesUDC();
      this.cargarEmpleadosDisponibles();
    } else {
      console.log('🖥️ [SaaS Prerender] Omitiendo consultas de red en Node.js de forma preventiva.');
    }
  }

  // 🚀 GETTER OPTIMIZADO: Reduce la carga de procesamiento en las directivas condicionales del HTML
  get an8Control() {
    return this.userForm.get('an8');
  }

  cargarRolesUDC(): void {
    console.log('📶 [JDE TELEMETRÍA ROLES] 1. Solicitando matriz de privilegios de ROLES al servidor...');
    
    // Consume tu catálogo unificado blindado contra NumberFormatException
    this.udcService.getCatBySystemCode('ROLES').subscribe({
      next: (roles: any[]) => {
        // 🔥 TELEMETRÍA AGRESIVA DE CONTROL DE ACCESOS
        console.log('📥 [JDE TELEMETRÍA ROLES] 2. Respuesta cruda recibida de Java. Longitud del array:', roles ? roles.length : 0);
        console.log('📋 [JDE TELEMETRÍA ROLES] 3. Contenido exacto de los roles devueltos por la DB:', roles);

        if (!roles || roles.length === 0) {
          console.warn('⚠️ [JDE TELEMETRÍA ROLES] ¡Alerta! La base de datos devolvió un arreglo VACÍO. Verifique el coId en MySQL.');
          return;
        }

        this.catRolesUdc = roles;
        const formArray = this.userForm.get('rolesSeleccionados') as FormArray;
        
        // Limpieza de control preventivo antes de poblar en caliente
        while (formArray.length !== 0) {
          formArray.removeAt(0);
        }

        // Inicializamos los checkboxes vacíos (false) listos para selección
        this.catRolesUdc.forEach((rol, index) => {
          console.log(`📦 [JDE TELEMETRÍA ROLES] Inyectando control reactivo para [Índice ${index}]:`, rol.description || rol);
          formArray.push(this.fb.control(false));
        });

        console.log('🔄 [JDE TELEMETRÍA ROLES] 4. Matriz de checkboxes cargada de forma exitosa en memoria RAM.');
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('❌ [JDE TELEMETRÍA ROLES] Fallo crítico al descargar catálogo de roles:', err);
        this.toastService.showDanger('Error de Comunicación', 'No se pudieron descargar los privilegios del taller.');
      }
    });
  }

  /**
   * 🚀 ENGRANAJE DE IDENTIDAD BLINDADO CONTRA CLIENTES:
   * Consume el nuevo endpoint de Spring Boot que extrae única y exclusivamente 
   * identidades físicas de tipo 'E' (Empleado) y 'M' (Mecánico/Técnico).
   */
  cargarEmpleadosDisponibles(): void {
    console.log('>>> [SECURITY JDE] Descargando personal interno legítimo (E/M) desde el servidor...');
    
    // 🟢 CAMBIO DE FONDO: Rompemos la dependencia con recepcionesService y clientes
    this.personalService.getPersonalInternoDisponible().subscribe({
      next: (data: any[]) => {
        // Mapeamos la respuesta simétrica devuelta por el mapa de Java (an8, nameAlpha, searchType)
        this.empleadosF0101 = data.map(emp => ({
          an8: emp.an8,
          alph: emp.nameAlpha || 'PERSONAL SIN NOMBRE',
          type: emp.searchType // Inyectamos el tipo para añadir un componente visual en el HTML
        }));
        
        console.log('>>> [SECURITY JDE] Personal interno cargado. Registros:', this.empleadosF0101.length);
        this.cdr.detectChanges(); 
      },
      error: (err) => {
        console.error('Error fatal al recuperar personal interno para usuarios:', err);
        this.toastService.showDanger(
          'Error de Conexión',
          'No se pudo descargar el catálogo de personal. Verifique el controlador.'
        );
        this.cdr.detectChanges();
      }
    });
  }

  get rolesControls() {
    return (this.userForm.get('rolesSeleccionados') as FormArray).controls;
  }

  onSubmit(): void {
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      this.toastService.showDanger('Formulario Incompleto', 'Por favor, llene todas las casillas obligatorias marcadas en rojo.');
      return;
    }

    const rawValue = this.userForm.getRawValue();
    const idsRolesFinales: number[] = [];
    
    rawValue.rolesSeleccionados.forEach((checked: boolean, index: number) => {
      if (checked) { idsRolesFinales.push(this.catRolesUdc[index].id); }
    });

    if (idsRolesFinales.length === 0) {
      this.toastService.showDanger('Falta Privilegio', 'Debe asignar obligatoriamente al menos un rol de la UDC.');
      return;
    }

    const nuevoUsuario = {
      userId: rawValue.userId.trim().toLowerCase(),
      an8: parseInt(rawValue.an8, 10),
      password: rawValue.password,
      enabled: rawValue.enabled,
      rolesUdcIds: idsRolesFinales
    };

    console.log('Despachando alta masiva atómica a Spring Boot:', nuevoUsuario);

    // =========================================================================
    // 🚀 SOLUCIÓN CORE: Conexión asíncrona real en vivo hacia Java
    // =========================================================================
    this.authService.registrarUsuarioServidor(nuevoUsuario).subscribe({
      next: (res) => {

        // 🚀 CERRAR MODAL CON ÉXITO: Envía la respuesta o un booleano verdadero hacia la lista
        this.dialogRef.close(res || true); 

      },
      error: (err) => {
        console.error('Error al registrar usuario en el servidor:', err);
        this.toastService.showDanger(
          'Fallo de Inserción',
          err.error?.error || 'El ID de usuario ya existe o el AN8 es inválido.'
        );
        this.cdr.detectChanges();
      }
    });
  }

  onCancelar(): void {
    this.dialogRef.close(false); // 🚀 Cierra retornando un false explícito
  }
    
}